import React, { Fragment, useState, useEffect } from 'react'
import { Button, CustomInput, Form, FormGroup, Input, Label, Row, Col, } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux'
import { Image } from 'react-feather';
import { useDropzone } from 'react-dropzone';
import { logoUrlRequest } from '../../helpers/requests';


export const Logo = (props) => {

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: 'image/jpeg, image/png',
    maxFiles: 1
  });

  const [image, setImage] = useState()
  const dispatch = useDispatch();

  useEffect(() => {
    if (acceptedFiles && acceptedFiles.length) {
      const file = acceptedFiles[0];
      const data = new FormData();
      data.append('myfile', file, file.name);
      logoUrlRequest({ params: data, dispatch: dispatch });

      // props.setFiles(acceptedFiles);
      // const _files = acceptedFiles.map(file => {
      //   console.log('file',file);
      //     var a = URL.createObjectURL(file);
      //     console.log('imageFile',a);
      //     setImage(a);
      // });
    }
  }, [acceptedFiles])

  const changeHandler = event => {
    const file = event.target.files[0];
    const data = new FormData();
    data.append('myfile', file, file.name);
    logoUrlRequest({ params: data, dispatch: dispatch });
  }

  return (
    <div>

      <div className='form-row'>
        <FormGroup>
          <div style={{ height: 'auto', border: '1px solid #00000021' }}>
            <Fragment>
              <Row>
                <Col className="pd-5">
                  <div className="drop-zone">
                    <div {...getRootProps({ className: 'dropzone' })} style={{ height: 'auto', padding: '4px', cursor: 'pointer' }}>
                      <input {...getInputProps()} />
                      <Row>
                        <Col className="text-center py-5">
                          <Image size={50} color={"silver"} className='' />
                          <p className="p-0 m-0 themeText" >Click or Drop and Image </p>
                        </Col>
                      </Row>
                      <Row>
                        <Col className='px-3'>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
              </Row>
            </Fragment>
          </div>
        </FormGroup>
         {props.image && 
         <input id='logo' type='file' onChange={changeHandler}/>}
      </div>
    </div>
  );
}
